import React from "react";
import { Dropdown } from "react-bootstrap";
import { LockIcon, LockIconBigger } from "./Icon";
import Input from "./Input";

const LockSection = () => {
	const [coin, setCoin] = React.useState("Solana");
	const [tab, setTab] = React.useState("create");
	const [value, setValue] = React.useState(0);
	return (
		<section
			className="lock-section poppins"
			style={{
				background: `url('/img/token-creators-bg.png') no-repeat top center / cover`,
			}}
		>
			<div className="container">
				<div className="lock-wrapper">
					<div
						className="d-flex justify-content-center position-relative"
						style={{ marginTop: "-45px", zIndex: 9 }}
					>
						<Dropdown className="lang-dropdown lock-dropdown">
							<Dropdown.Toggle>
								<img src="/img/logo3.png" alt="" />
								<span className="icon-menu">{coin}</span>
							</Dropdown.Toggle>
							<Dropdown.Menu>
								{coins?.map((item) => (
									<Dropdown.Item
										key={item.id}
										onClick={() => setCoin(item?.name)}
									>
										<img src={item.img} alt="" />
										<span className="icon-menu">{item.name}</span>
									</Dropdown.Item>
								))}
							</Dropdown.Menu>
						</Dropdown>
					</div>
					<div className="lock-tab-group mt-20 mb-3">
						<button
							className={`lock-tab-button ${
								tab === "create" ? "active" : ""
							}`}
							onClick={() => setTab("create")}
						>
							<LockIcon /> <span>Create New Lock</span>
						</button>
						<button
							className={`lock-tab-button ${
								tab === "view" ? "active" : ""
							}`}
							onClick={() => setTab("view")}
						>
							<LockIcon /> <span>View Created Locks</span>
						</button>
					</div>
					<div className="mb-3">
						<Input
							placeholder="Enter Address here..."
							label="Lock Address"
							style={{
								border: "none",
								background: "rgba(5, 5, 6, 0.65)",
								backdropFilter: "blur(6.8717498779296875px)",
							}}
						/>
					</div>
					<div className="lock-content">
						<div className="item">
							<span className="font-medium">Name</span>
							<span>Solana</span>
						</div>
						<div className="item">
							<span className="font-medium">Symbol</span>
							<img src="/img/logo3.png" width={20} alt="" />
						</div>
						<div className="item">
							<span className="font-medium">Name</span>
							<span>Solana</span>
						</div>
					</div>
					<div className="text-center py-4 my-2">
						<LockIconBigger />
						<div className="mt-3">
							<div>
								<strong className="text-14">Unlock Date</strong>
							</div>
							<div className="text-gradient d-inline-block text-capitalize text-10">
								24 Jan, 2023
							</div>
						</div>
					</div>
					<div className="balance-card text-12">
						<span className="text-gradient d-inline-block text-capitalize me-2">
							24 Jan, 2023
						</span>
						<span className="font-semibold">17,961 SOL</span>
					</div>
					<div className="quantity-group">
						<div className="top">
							<button
								className="no-gutter"
								onClick={() => setValue(parseInt(value) - 1)}
							>
								-
							</button>
							<div className="position-relative w-0 flex-grow-1">
								<span className="value">{value || 0} SOL</span>
								<input
									type="number"
									value={value}
									className="form-control"
									onChange={(e) => setValue(e.target.value)}
									min={0}
								/>
							</div>
							<button
								className="no-gutter"
								onClick={() =>
									setValue(value ? parseInt(value) + 1 : 1)
								}
							>
								+
							</button>
						</div>
						<div className="bottom">
							<button
								className="text-10 no-gutter"
								onClick={() => setValue(25)}
							>
								25
							</button>
							<button
								className="text-10 no-gutter"
								onClick={() => setValue(50)}
							>
								50
							</button>
							<button
								className="text-10 no-gutter"
								onClick={() => setValue(75)}
							>
								75
							</button>
							<button
								className="text-10 no-gutter"
								onClick={() => setValue(100)}
							>
								100
							</button>
						</div>
					</div>
					<div className="text-center mt-4">
						<button className="btn-base border-0 w-100">
							<LockIcon /> <span className="ms-2">Lock Liquidity (Coming soon)</span>
						</button>
					</div>
				</div>
			</div>
		</section>
	);
};

const coins = [
	{
		id: 1,
		name: "Solana",
		img: "/img/logo2.png",
	},

];
export default LockSection;
